import axiosInstance from "../libs/axiosInstance";


export const initializeSubscription = async () => {
    try {
      const response = await axiosInstance.post('/subscriptions/initialize/');
      return response.data;
    } catch (error) {
      console.error('Error iitializing subscription:', error.message);
      throw error;
    }
};

export const verifySubscription = async (reference) => {
    try {
      const response = await axiosInstance.post('/subscriptions/verify/', { reference });
      return response.data;
    } catch (error) {
      console.error('Error verifying subscription:', error);
      throw error;
    }
}